import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import './Header.css';

function Header() {
  return (
    <Navbar bg="light" expand="lg" className="rjc-navbar">
      <Container>
        <Navbar.Brand href="#home" className="rjc-brand">Russell Blanchard Creations</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link href="#gallery">Gallery</Nav.Link>
            <Nav.Link href="#about">About</Nav.Link>
            <Nav.Link href="#contact">Order Form</Nav.Link>
            <div className="contact-info-stack">
              <Nav.Link href="tel:+1-225-202-7145">+1 (225) 202-7145</Nav.Link>
              <Nav.Link href="mailto:russellblanchardcreations@gmail.com">russellblanchardcreations@gmail.com</Nav.Link>
            </div>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;